import React from 'react';
import './App.css';
import '@fontsource/inter';
import { AppRouter } from './app/router';
import { ModalProvider } from './app/providers/ModalProvider';

function App() {
  return (

    <div className="App">
      <ModalProvider/>
      <AppRouter/>

    </div>
  );
}

export default App;
